import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from '@cabukaka/contexts/index';
import { initConfig } from '@cabukaka/config';


initConfig({
  apiUrl: import.meta.env.VITE_PUBLIC_API_URL+"/api"!,
  firebase: {
    apiKey: import.meta.env.VITE_PUBLIC_FIREBASE_API_KEY!,
    authDomain: import.meta.env.VITE_PUBLIC_FIREBASE_AUTH_DOMAIN!,
    projectId: import.meta.env.VITE_PUBLIC_FIREBASE_PROJECT_ID!,
    storageBucket: import.meta.env.VITE_PUBLIC_FIREBASE_STORAGE_BUCKET!,
    messagingSenderId: import.meta.env.VITE_PUBLIC_FIREBASE_MESSAGING_SENDER_ID!,
    appId: import.meta.env.VITE_PUBLIC_FIREBASE_APP_ID!
  }
});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);